import { useAuth0 } from '@auth0/auth0-react';
import { Link } from '@tanstack/react-router';

const UnauthorizedPage = () => {
  const { user, logout } = useAuth0();
  const url = '/';

  return (
    <div className="flex flex-col items-center justify-center h-screen px-6">
      <div>
        <p>
          Thank you for signing up. Please contact{' '}
          <a
            className="text-blue-500 hover:underline hover:cursor-pointer"
            href="mailto:helpline@ingleinternational.com?subject=Student Admin Portal Setup"
            target="_blank"
            rel="noopener noreferrer"
          >
            customersupport@inglelewer.ca
          </a>{' '}
          with the subject line &quot;Student Admin Portal Setup&quot; and
          include the email you used to signup and we will complete the
          registration process.
        </p>
      </div>
      <Link
        className="w-full md:w-1/2 md:h-16 rounded-lg px-6 py-4 mt-8 mb-2 bg-ingle-light-purple text-white text-center font-bold text-lg hover:cursor-pointer hover:scale-105 hover:shadow-lg"
        to="/"
        reloadDocument
      >
        Try Again
      </Link>

      <span>
        {user?.email ? `Not ${user.email}?` : null}
        &nbsp;
        <a
          href={url || '/'}
          className="text-blue-500 hover:underline"
          onClick={e => {
            e.preventDefault();
            logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
            });
          }}
        >
          Click Here to logout
        </a>
      </span>
    </div>
  );
};

export default UnauthorizedPage;
